<div class="error-container">
  <pop-icon-warning class="bg-image"></pop-icon-warning>
  <div class="content-wrapper">
    <div>
      <ng-content select="[title]"></ng-content>
    </div>
    <div>
      <ng-content select="[description]"></ng-content>
    </div>
    <div>
      <ng-content select="[action]"></ng-content>
    </div>
  </div>
  <div class="brand-name-image"></div>
</div>
